import { processIncomingMobilityBasicInfoRoute } from './0ProcessIncomingMobilityBasicInfoPage/route';
import { processIncomingMobilityDocumentsPageRoute } from './1ProcessIncomingMobilityDocumentsPage/route';
import { processIncomingMobilityPaymentOrderRoute } from './2ProcessIncomingMobilityRecurringPaymentsPage/route';
import { processIncomingMobilityRecapitulationRoute } from './3ProcessIncomingMobilityRecapitulationPage/route';
import { processIncomingMobilityRoute } from './route';

export const processIncomingMobilityRoutes =
	processIncomingMobilityRoute.addChildren([
		processIncomingMobilityBasicInfoRoute,
		processIncomingMobilityDocumentsPageRoute,
		processIncomingMobilityPaymentOrderRoute,
		processIncomingMobilityRecapitulationRoute,
	]);
